import React, { useState, useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter } from "react-router-dom";

import { StorageHandler, Nav } from "C4";

import { storageKeys } from "settings";

const HeaderSub = ({ history, location }) => {
  const [logo, setLogo] = useState(null);
  const { pathname } = location;
  const [returnPath] = pathname.match(/\/(.*?)\/(.*?)\//g);

  const getAppInfo = async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      setLogo(appInfo.logo_white);
    }
  };

  useEffect(() => {
    getAppInfo();
  }, []);

  return (
    <div className="header header-sub">
      <Nav pathname={pathname} />
      <nav>
        <ul>
          <button
            onClick={() =>
              history.push(returnPath.substring(0, returnPath.length - 1))
            }
          >
            <FontAwesomeIcon icon={["fas", "chevron-left"]} /> Back
          </button>
          {logo && <img src={`${logo}`} className="logo" alt="logo" />}
        </ul>
      </nav>
    </div>
  );
};

export default withRouter(HeaderSub);
